import * as Yup from 'yup';
import { EMAIL_VALIDATION_PATTERN } from '../../constants/patterns';

export default Yup.object().shape({
  email: Yup.string()
    .matches(EMAIL_VALIDATION_PATTERN, 'validationErrors.invalidEmail')
    .required('validationErrors.isRequired'),
});
